interface Prop {
  children: JSX.Element
  className?: string
}

const FormLayout = ({ children, className }: Prop) => {
  return (
    <div className={`w-full rounded-md border-2 bg-white p-6 ${className}`}>
      {children}
    </div>
  )
}

export default FormLayout
